import { ReactNode } from "react";
import PermissionWrapper from "./PermissionWrapper";
import { Action } from "./types";

interface PermissionNavItemProps {
  requiredPermissions?: Action | Action[];
  children: ReactNode;
}

export const PermissionNavItem = ({
  requiredPermissions,
  children,
}: PermissionNavItemProps) => {
  if (!requiredPermissions) {
    return <>{children}</>;
  }

  return (
    <PermissionWrapper actions={requiredPermissions} fallback={null}>
      {children}
    </PermissionWrapper>
  );
};
